import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { setComplete } from '../../actions/user-api';
import $ from 'jquery';

// Anticipa
// ==========================================
// Anticipa: Common
import { Navbar } from './_common/navbar';
import { Help } from './_common/help';
import JwtDecode from 'jwt-decode';
// Anticipa: Views
import {Onboard} from './onboard';
import {Dashboard} from './dashboard';
import {Referent} from './referent';
import {Communes} from './communes';
import {Personal} from './personal';
import {Biblioteque} from './biblioteque';
import { Settings } from './settings';
import SigninIlustration from './../../assets/images/placeholder/Signin-ilustration.svg';
import * as Loadings from '../../constants/loadings/user';
import {FileTypes} from '../../constants/utils/fileTypes';
import * as R from 'ramda';
import * as axios from 'axios';
import {getUserAddress, getUserRepresentatives, getUserRepresentativeAddress, getUserServices, getDocuments, getProfilePicture, fetchUserById, getUserMessage, fetchPartnerCustomization} from '../../actions/user-api';
import {fetchAllServiceData} from '../../actions/services-api';

export const Anticipa = () => {
	const user = useSelector(state => state.user);
	// const auth = useSelector(state => state.auth);
	const router = useSelector(state => state.router);
	const dispatch = useDispatch();

	const location = useLocation();
	const history = useHistory();

	const [partnerCustomization, setPartnerCustomization] = useState({
		isLoaded: false,
		logoBase64Encoded: undefined,
		color: undefined
	  });

	const queryParams = new URLSearchParams(location.search);
	if(queryParams.has('fc')){
		$('#commencerAnticipa').modal('show');
	}

	useEffect(() => {
		let authToken = localStorage.getItem("access_token");
		if (!R.isNil(authToken)) {
		  axios.defaults.headers.common['Authorization'] = "Bearer " + authToken;
		}
	  }, [])

	useEffect(() => {
		if (user.user === undefined && !user.isLoading.includes(Loadings.FETCH_USER)) {
			var accessToken = localStorage.getItem("access_token");
			if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
			  var decoded = JwtDecode(accessToken);
			  if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
				dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
			  }
			}
		}else{
			let tmpUser = user.user;
			if (!R.isNil(tmpUser)) {
				if(!R.isNil(tmpUser.partnerId) && tmpUser.partnerId !== '00000000-0000-0000-0000-000000000000'){
					fetchPartnerCustomization(tmpUser.partnerId)
					.then((customization) => {
						if(!R.isNil(customization)){
							setPartnerCustomization({...customization, isLoaded: true});
						}
					}).catch(() => setPartnerCustomization({...partnerCustomization, isLoaded: true}))
				}else{
					setPartnerCustomization({...partnerCustomization, isLoaded: true})
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.user]);

	useEffect(() => {
		if(!R.isNil(user.user)){
			dispatch(getUserAddress(user.user.id));
			dispatch(getUserRepresentatives(user.user.id));
			dispatch(getUserServices(user.user));
			dispatch(getDocuments(user.user));
			dispatch(getUserMessage());
			dispatch(fetchAllServiceData());
		}
	}, [partnerCustomization]);



	useEffect(() => {
		const profilePicture = user.documents.find(d => d.fileType === FileTypes.ProfilePicture);
		if(!R.isNil(profilePicture))
			dispatch(getProfilePicture(user.user.id, profilePicture.fileName));
	}, [user.documents]);

	useEffect(() => {
		if(!R.isNil(user.referents) && user.referents.length > 0){
			user.referents.forEach(r => {
			dispatch(getUserRepresentativeAddress(r))
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.referents]);

	let authToken = localStorage.getItem("access_token");
    if (R.isNil(authToken)) {
		return (
					<div className={"layout layout-row" + (!R.isNil(partnerCustomization) && !R.isNil(partnerCustomization.color) && partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{backgroundColor: "#" + partnerCustomization.color }}>
						<h1 className="sr-only visually-hidden">Assist@</h1>
						<Navbar location={router.location} user={user.user} logoContent={partnerCustomization.logoBase64Encoded} />
						<main role="main" className="view flex-grow-1 bg-gradient-light">
							<section className="flex-column align-items-center justify-content-center h-inherit">
								<img className="img-fluid img-contain mx-auto mb-4" src={SigninIlustration} alt="Assist@" />
								<div className="block text-center">
									<h1 className="font-weight-bolder ls-n1 lh-1">Votre session a expiré</h1>
									<p className="o-80 mb-4">Vous devrez vous reconnecter avec votre compte Assist@ pour continuer.</p>
									<Link to="/auth/signin" type="button" className="btn btn-primary px-4 rounded-sm" onClick={() => {
										localStorage.removeItem("access_token");
									}
									}>OK</Link>
								</div>
							</section>
						</main>
					</div>
		);
	}

	if (R.isNil(user.user) || !partnerCustomization.isLoaded) {
		return '';
	}

	let step = !R.isNil(user.user.onBoardingStep) ? parseInt(JSON.stringify(user.user.onBoardingStep).replace(/\D/g, "")) : -1;
	if (step !== 6 && step !== -1) {
		if(user.user.onBoardingStep !== "Completed"){
			window.location = `/auth/signup/step${(step+1)}`;
			return '';
		}
	}

	return (
		<div className={"layout layout-row" + (!R.isNil(partnerCustomization) && !R.isNil(partnerCustomization.color) && partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{backgroundColor: "#" + partnerCustomization.color }}>
			<h1 className="sr-only visually-hidden">Assist@</h1>
			<Navbar location={router.location} user={user.user} profilePicture={user.profilePicture} profilePictureDocument={user.documents.find(d => d.fileType === FileTypes.ProfilePicture)}  logoContent={partnerCustomization.logoBase64Encoded}/>
			<main role="main" className="view flex-grow-1 bg-gradient-light">
				<h1 className="sr-only visually-hidden">Assist@: Main</h1>
				<Help />
				{!R.isNil(user.user.setupCompletedDate)?
					<Switch>
						<Route path="/anticipa/dashboard/" component={Dashboard} />
						<Route path="/anticipa/referent/" component={Referent} />
						<Route path="/anticipa/communes/" component={Communes} />
						<Route path="/anticipa/personal/" component={Personal} />
						<Route path="/anticipa/biblioteque/">
							<Biblioteque userId={user.user.id}  files={user.documents} isLoading={user.isLoading} />
						</Route>
						<Route path="/anticipa/settings/" component={Settings} />

						<Route render={() => {
							return <Redirect exact to={"/anticipa/dashboard"} />
						}} />
					</Switch>
					:
					<Switch>
						<Route exact path="/anticipa" component={Onboard} />
						<Route path="/anticipa/referent/" component={Referent} />
						<Route path="/anticipa/communes/" component={Communes} />
						<Route path="/anticipa/personal/" component={Personal} />
						<Route path="/anticipa/biblioteque/">
							<Biblioteque userId={user.user.id} files={user.documents} isLoading={user.isLoading} />
						</Route>
						<Route path="/anticipa/settings/" component={Settings} />

						<Route render={() => {
							return <Redirect exact to={"/anticipa"} />
						}} />
					</Switch>
				}
			</main>
			{ (router.location.pathname.toLowerCase() === '/anticipa') ?
				<div className="modal fade px-0" id="commencerAnticipa" aria-labelledby="commencerAnticipaLabel" aria-hidden="true">
					<div className="modal-dialog px-2">
						<div className="modal-content">
							<div className="modal-body">
								<div className="container-copy">
									<h5 className="h1 text-primary font-weight-bolder ls-n1 lh-copy mb-0 mt-4 mt-lg-auto text-uppercase" id="commencerAnticipaLabel">Astuces:</h5>
									<p className="h3 lh-copy mt-2">Pour votre confort afin de compléter rapidement et simplement tous les onglets.</p>
								</div>
								<hr className="my-4"/>
								<ul className="list-unstyled lh-base mb-3">
									<p className="fs-inherit mb-2">Nous vous conseillons de prévoir vos dossiers à proximité de vous afin de faciliter la complétude de celui-ci:</p>
									<li><span className="o-60 mr-2">—</span> Dossier impôt</li>
									<li><span className="o-60 mr-2">—</span> Dossier maison : <span className="o-80">électricité, gaz, entretien , télévision , internet, eau…</span></li>
									<li><span className="o-60 mr-2">—</span> Vos dossiers banque et assurance</li>
									<li><span className="o-60 mr-2">—</span> Votre carte de mutuelle</li>
								</ul>
								<p className="fs-inherit mb-3">Des cases commentaires sont mises à votre disposition pour chacun de vos placements et abonnements. Vous pouvez noter le montant de vos prélèvements et/ou capitaux dans celles-ci afin d’avoir un suivi personnel.
								<br/>Les données mises dans ces cases restent personnelles, confidentielles et ne seront pas lisibles, ni utilisées dans les courriers.
								<br/>C’est un service complémentaire mis en place pour vous.</p>
								<p className="fs-inherit mb-3">Les adresses sur notre plateforme ont été fournies par vos organismes pour résilier ou modifier votre contrat ou abonnement suite au décès. C’est pour cela que les adresses peuvent être différentes de vos services souscriptions ou adhésions.</p>
								<p className="fs-inherit">Bon dossier,</p>
							</div>
							<div className="modal-footer mt-4 mt-lg-auto py-2">
								<button type="button" className="btn btn-info" data-dismiss="modal" onClick={
									(e) => {
										e.preventDefault();
										history.replace({
											search: '',
										})
									}
								}>Commencer</button>
							</div>
						</div>
					</div>
				</div> : ''
			}
		</div>
	)
}
